<form>
  <h2 mat-dialog-title>Upload files</h2>
  <mat-dialog-content>
    <mat-list>
      <mat-list-item *ngFor="let row of queue">
        <h4 matListItemTitle>{{row.file.name}}</h4>
        <mat-progress-bar [value]="row.progress" mode="determinate"></mat-progress-bar>
        <div class="fill-remaining-space"></div>
        <button (click)="removeFromQueue(row)" mat-icon-button>
          <mat-icon>delete</mat-icon>
        </button>
      </mat-list-item>
      <mat-list-item *ngIf="queue.length === 0">
        <p>There are no files in the queue, please pick some files with the button "add files".</p>
      </mat-list-item>
    </mat-list>
  </mat-dialog-content>
  <mat-dialog-actions>
    <input #file (change)="addToQueue()" multiple style="display: none" type="file"/>
    <button (click)="addFiles()" [disabled]="isUploading()" class="add-files-btn" color="primary" mat-raised-button type="button">
      Add Files
    </button>
    <div class="fill-remaining-space"></div>
    <button (click)="close()" [disabled]="hasQueue() || isUploading()" mat-raised-button type="button">Close</button>
    <app-button (onClick)="startUpload()" [isLoading]="isUploading()" title="Start upload"></app-button>
  </mat-dialog-actions>
</form>
